import { statusChipTone } from '../theme/tokens';
import { useLanguage } from './language-context';
import type { MessageKey } from '@bookingdei/i18n/message-key';
import type { StatusEntity } from '@bookingdei/i18n/status-label';

// One status chip for every admin domain (booking, business, application,
// subscription-payment, dispute, user, review-flag). The TONE comes from
// packages/i18n status-tone (CB-15) — per `entity` when the caller knows it — and
// is painted with the theme's chip pair (`.tone--*`, design chip() + dark tone()).
// The label comes from i18n (`admin.status.<value>`) with a humanized fallback for
// unknown enum values (AP-D10 — clients tolerate unknown values).
function humanize(value: string): string {
  return value.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
}

export function StatusChip({ status, entity }: { status: string; entity?: StatusEntity }) {
  const { t } = useLanguage();
  const tone = statusChipTone(status, entity);
  const key = `admin.status.${status}` as MessageKey;
  const label = t(key);
  return (
    <span className={`status-badge tone--${tone}`} data-tone={tone}>
      {label === key ? humanize(status) : label}
    </span>
  );
}
